import { Image, imageSrc } from 'src/shared/frontendTypes/images'

const getImageAlt = (
  image: Image | imageSrc | undefined | null,
  fallback: string,
) => image?.altTag?.trim() || fallback

export default getImageAlt
